export function downloadFile(idFile: number) {
    const link = document.createElement('a');
    link.href = `/downloadFile.php?id=${idFile}`;
    link.click();
    link.remove();
    return;
}

export function pad(value: string) {
    return String(value).padStart(2, '0');
}

export function sizeResize(
    width: number,
    height: number,
    maxWidth = 0,
    maxHeight = 0,
): { width: number; height: number } {
    let outputWidth = width;
    let outputHeight = height;
    let r = 1;

    if (width > maxWidth && maxWidth !== 0) {
        r = maxWidth / width;
        outputWidth = maxWidth;
        outputHeight = Math.round(height * r);
    }
    if (height > maxHeight && maxHeight !== 0) {
        r = maxHeight / height;
        outputWidth = Math.round(width * r);
        outputHeight = maxHeight;
    }

    return { width: outputWidth, height: outputHeight };
}
